import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../api/client';
import { getScenarioForMission, loadRuntimeScenario } from '../data/scenarios';

/** An element URL can be opened without visiting its chapter first. */
export function useMissionScenario(rawMissionId: unknown) {
  const missionId = Number(rawMissionId);
  const { user, getAccessToken } = useAuth();
  const [revision, setRevision] = useState(0);
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!missionId) { setStatus('error'); return; }
    if (getScenarioForMission(missionId) && attempt === 0) {
      setStatus('ready');
      return;
    }
    setStatus('loading');
    const token = getAccessToken();
    // Auth restores asynchronously on a hard reload. Retry when the user arrives.
    if (!token) return;
    void loadRuntimeScenario(missionId,
      () => apiFetch(`/me/stories/${missionId}/scenario`, { token, auth: true }), true)
      .then(() => {
        if (!cancelled) { setRevision(n => n + 1); setStatus('ready'); }
      })
      .catch(() => { if (!cancelled) setStatus('error'); });
    return () => { cancelled = true; };
  }, [missionId, user, getAccessToken, attempt]);
  return { revision, status, retry: () => setAttempt(n => n + 1) };
}
